/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import {
  bootstrapUtils,
} from 'react-bootstrap/lib/utils';
import {
  Button,
  DropdownButton,
  Nav,
  Navbar,
  Panel,
  ProgressBar,
  SplitButton,
  Tabs,
} from 'react-bootstrap';
import './sass/bootstrap.scss';

function InitButtonTheme() {
  bootstrapUtils.addStyle(Button, 'aisz-default');
  bootstrapUtils.addStyle(Button, 'aisz-default-o');
  bootstrapUtils.addStyle(Button, 'aisz-default-b');
  bootstrapUtils.addStyle(Button, 'aisz-info');
  bootstrapUtils.addStyle(Button, 'aisz-info-b');
  bootstrapUtils.addStyle(Button, 'aisz-info-o');
  bootstrapUtils.addStyle(Button, 'aisz-primary');
  bootstrapUtils.addStyle(Button, 'aisz-primary-o');
  bootstrapUtils.addStyle(Button, 'aisz-primary-b');
  bootstrapUtils.addStyle(Button, 'aisz-primary-ob');
  bootstrapUtils.addStyle(Button, 'aisz-success');
  bootstrapUtils.addStyle(Button, 'aisz-success-o');
  bootstrapUtils.addStyle(Button, 'aisz-success-b');
  bootstrapUtils.addStyle(Button, 'aisz-warning');
  bootstrapUtils.addStyle(Button, 'aisz-warning-o');
  bootstrapUtils.addStyle(Button, 'aisz-danger');
  bootstrapUtils.addStyle(Button, 'aisz-danger-o');
  bootstrapUtils.addStyle(Button, 'aisz-danger-b');
  bootstrapUtils.addStyle(Button, 'aisz-transparent');
  bootstrapUtils.addStyle(Button, 'aisz-link');
  bootstrapUtils.addStyle(Button, 'aisz-link-default');
  bootstrapUtils.addStyle(Button, 'aisz-link-danger');
  bootstrapUtils.addStyle(Button, 'aisz-link-warning');
  bootstrapUtils.addStyle(Button, 'aisz-link-success');
  bootstrapUtils.addStyle(Button, 'aisz-light');
}

function InitFormTheme() {}

function InitPanelTheme() {
  bootstrapUtils.addStyle(Panel, 'aisz-transparent');
  bootstrapUtils.addStyle(Panel, 'aisz-white');
  bootstrapUtils.addStyle(Panel, 'aisz-warning');
  bootstrapUtils.addStyle(Panel, 'aisz-danger');
  bootstrapUtils.addStyle(Panel, 'aisz-info');
  bootstrapUtils.addStyle(Panel, 'aisz-light');
}

function InitModalTheme() {}

function InitNavs() {
  bootstrapUtils.addStyle(Nav, 'aisz-pills');
  bootstrapUtils.addStyle(Nav, 'aisz-tabs');
  bootstrapUtils.addStyle(Navbar, 'aisz-white');
  bootstrapUtils.addStyle(Navbar, 'aisz-transparent');
}

function InitTabs() {
  bootstrapUtils.addStyle(Tabs, 'aisz-tabs');
}

function InitProgressBar() {
  bootstrapUtils.addStyle(ProgressBar, 'aisz-primary');
  bootstrapUtils.addStyle(ProgressBar, 'aisz-success');
}

function InitDropdownButton() {
  bootstrapUtils.addStyle(DropdownButton, 'aisz-primary-b');
  bootstrapUtils.addStyle(DropdownButton, 'aisz-primary');
  bootstrapUtils.addStyle(DropdownButton, 'aisz-transparent');
  bootstrapUtils.addStyle(DropdownButton, 'aisz-success');
  bootstrapUtils.addStyle(DropdownButton, 'aisz-success-b');
  bootstrapUtils.addStyle(DropdownButton, 'aisz-danger-b');
  bootstrapUtils.addStyle(SplitButton, 'aisz-primary');
  bootstrapUtils.addStyle(SplitButton, 'aisz-default-b');
}

function InitTheme() {
  InitButtonTheme();
  InitFormTheme();
  InitPanelTheme();
  InitModalTheme();
  InitNavs();
  InitTabs();
  InitProgressBar();
  InitDropdownButton();
}

export {
  InitTheme,
  InitButtonTheme,
  InitFormTheme,
  InitPanelTheme,
  InitModalTheme,
  InitProgressBar,
  InitDropdownButton,
  InitTabs,
};

(function f() {
  InitTheme();
}());




// WEBPACK FOOTER //
// ./src/themes/aisz/index.js